import {
  DatePicker,
  Collapse,
  Select,
  Button,
  Radio,
  Table,
  Drawer,
  Modal,
  Input
} from "antd";
import React, { useEffect, useState } from "react";
import { BreathAPIs } from "../../APIs/BreathAPIs";
import { Container } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import styles from "./styles.module.css";
import { get } from "react-scroll/modules/mixins/scroller";
import CreateBid from "./CreateBid";
import ViewBid from "./ViewBid";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { json } from "react-router-dom";
import { use } from "react";
import { render } from "@testing-library/react";
import { FaEye } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { IoDuplicateOutline, IoEyeOutline } from "react-icons/io5";
import ViewDeal from "./ViewDeal";
import BidDetailModal from "./BidDetailModal";
import { LiaCommentsSolid } from "react-icons/lia";
import BidDataUpdateHubSpot from "./BidDataUpdateHubSpot";

const Deals = ({ userGroups, phone, email }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSyncLoading, setIsSyncLoading] = useState(false);

  // const [isDealLoading,setIsDealLoading] = useState(false)
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
    totalPages: 0,
  });
  const [dealsData, setDealsData] = useState([]);
  const [bidsData, setBidsData] = useState([]);
  const [showBidCreateModel, setShowBidCreateModel] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [lastSync, setLastSync] = useState("1997-01-01T00:00:00.000Z");

  const [selectedBidToView, setSelectedBidToView] = useState(null);
  const [showBidViewModal, setShowBidViewModal] = useState(false);
  const [showApproverButton, setShowApproverButton] = useState(false);
  const [isApproverView, setIsApproverView] = useState(false);
  const [isPendingDealsView, setIsPendingDealsView] = useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [bidsDataForApproval, setBidsDataForApproval] = useState([]);
  const [viewCommentsForBid, setViewCommentsForBid] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [viewEditBidModal, setViewEditBidModal] = useState(false);
  const [editBidData, setEditBidData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [dealsWithBidsFilter, setDealsWithBidsFilter] = useState(0); // 0 - All, 1 - With Bids, 2 - Without Bids
  const [dealModalView, setDealModalView] = useState(false);
  const [dealToView, setDealToView] = useState(null);
  const [showBidDetailModal, setShowBidDetailModal] = useState(false);
  const [selectedBidForDetail, setSelectedBidForDetail] = useState(null);
  const [showHubspotUpdateModal, setShowHubspotUpdateModal] = useState(false);
  const [selectedDealForHubspotUpdate, setSelectedDealForHubspotUpdate] = useState(null)

  // const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  // console.log("userGroups prop: ", userGroups);
  useEffect(() => {
    if (userGroups) {
      userGroups.filter((grps) => {
        let permissions = JSON.parse(grps.permissions);
        if (permissions?.bidApprover && permissions?.bidApprover === "yes") {
          setShowApproverButton(true);
        }
      });
    }

  }, []);

  useEffect(() => {
    setExpandedRowKeys([]);
  }, [isApproverView]);

  const createBidModalEnable = (deal) => {
    setSelectedDeal(deal);
    setShowBidCreateModel(true);
  };
  useEffect(() =>{
    //getAllDeals();
     getAllLiveDeals();
  },[])

  useEffect(() => {
    // getAllDeals();
    console.log("showBidCreateModel changed: ", showBidCreateModel);
    if(showBidCreateModel === false){
      // console.log("Refreshing deals data after closing bid create modal");
       if(isPendingDealsView){
      getPendingDeals(pagination.current, pagination.pageSize);
    }else if(isApproverView){
      getAllLiveDeals(true, pagination.current, pagination.pageSize);
    }else{
      getAllLiveDeals(false, pagination.current, pagination.pageSize);
    }
    }
   
  }, [showBidCreateModel]);

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    isPendingDealsView ? getPendingDeals(current, pageSize) : getAllLiveDeals(isApproverView, current, pageSize, filters);
  };

  const viewDealModal = (deal) => {
    setDealToView(deal);
    setDealModalView(true);
    console.log("deal to view: ", deal);
  };

  const handleUpdateHubspotModalClick = (record) =>{
    setSelectedDealForHubspotUpdate(record)
    setShowHubspotUpdateModal(!showHubspotUpdateModal)
  }

  const column = [
    {
      title: "Name",
      dataIndex: "dealname",
      key: "dealname",
      fixed: "left",
      render: (record, text) => {
        return (
          <div className={styles['link-text']} onClick={() => viewDealModal(text)}> 
            {text?.dealname || "Not Available"}
          </div>
        )
      },
    },
    {
      title: "Installer",
      dataIndex: "installer_name",
      key: "installer_name",
      render: (record, text) => text?.installer_name || "Not Available",
    },
    {
      title: "Address",
      dataIndex: "property_address",
      key: "property_address",
      render: (record, text) => text?.property_address || "Not Available",
    },
    {
      title: "Created At",
      dataIndex: "createdate",
      key: "createdate",
      render: (record, text) => {
        if (text) {
          const date = new Date(text?.createdate);
          return date.toLocaleString(); // This will format the date nicely
        }
        return "Not Available";
      },
    },
    {
      title: "Owner",
      dataIndex: "hubspot_owner_id",
      showSorterTooltip: { target: "full-header" },
      filters: [
        ...new Set(dealsData.map((deal) => deal.hubspot_owner_id).filter(Boolean)),
      ].map((owner) => ({
        text: owner,
        value: owner,
      })),
      //   onFilter: (value, record) => record.owner === value,

      key: "hubspot_owner_id",
      render: (record, text) => text?.hubspot_owner_id || "Not Available",
    },
    {
      title: "Property State",
      dataIndex: "property_state",
      showSorterTooltip: { target: "full-header" },
      filters: [
        ...new Set(dealsData.map((deal) => deal.property_state).filter(Boolean)),
      ].map((propertyState) => ({
        text: propertyState,
        value: propertyState,
      })),
      //   onFilter: (value, record) => record.propertyState === value,
      key: "property_state",
      render: (record, text) => text?.property_state || "Not Available",
    },
    {
      title: "Stage",
      dataIndex: "dealstage",
      showSorterTooltip: { target: "full-header" },
      filters: [
        ...new Set(dealsData.map((deal) => deal.dealstage).filter(Boolean)),
      ].map((dealStage) => ({
        text: dealStage,
        value: dealStage,
      })),
      //   onFilter: (value, record) => record.dealStage === value,
      key: "dealstage",
      render: (record, text) => text?.dealstage || "Not Available",
    },
    {
      title: "L2 Charger Count",
      dataIndex: "l2_chargers",
      key: "l2_chargers",
      render: (record, text) => record || 0
    },
    {
      title: "L3 Charger Count",
      dataIndex: "l3_chargers",
      key: "l3_chargers",
      render: (record, text) => record || 0
    },
    {
      title: "Bids",
      dataIndex: "bidCount",
      key: "bidCount",
      render: (record, text) => record || 0
    },
    {
      title: "",
      key: "createBid",
      width: 120,
      // fixed: 'right',
      render: (record, text) => (
        <>
          {record.dealstage === "Pending Bid" 
          // ||
          //   record.dealstage === "Bid Sent" ||
          //   record.dealstage === "Bid Approved"
             ? (
            <Button
              className={styles["custom-button"]}
              type="button"
              onClick={() => createBidModalEnable(record)}
            >
              Create Bid
            </Button>
            
          ) : (
            <></>
          )}
        </>
      ),
    },
    {
      title: "",
      key: "Update Hubspot",
      width: 120,
      // fixed: 'right',
      render: (record, text) => (
        <> 
            <Button
              className={text?.bidCount <= 0 ? styles['disabled-btn'] : styles["custom-button"]}
              type="button"
              onClick={() => handleUpdateHubspotModalClick(record)}
              disabled={text?.bidCount <= 0}
            >
              Update Hubspot
            </Button>
            
         
        </>
      ),
    },
  ];
  const handleViewComments = (record) => {
    setViewCommentsForBid(record.comments);
    setShowCommentsModal(true);
  };

  const handleDuplicateBid = async (record) => {
    let selectedDeal = dealsData.find(
      (deal) => deal._id.toString() === record.dealId._id.toString()
    );


    const { _id, ...recordWithoutId } = record;
    recordWithoutId.bidStatus = "DRAFT";
    recordWithoutId.acceptedProposal = false;
    recordWithoutId.selectedApproverList = [];  

    try {
      let response = await BreathAPIs.createBid(recordWithoutId, selectedDeal._id);
      if (response.status === 200) {
        toast.success("Bid Duplicated Successfully");
        setShowBidCreateModel(false);
        getDealBids(selectedDeal._id);
        if(isPendingDealsView){
          getPendingDeals(pagination.current, pagination.pageSize);
        }else if(isApproverView){
          getAllLiveDeals(true, pagination.current, pagination.pageSize);
        }else{
          getAllLiveDeals(false, pagination.current, pagination.pageSize);
        }
      } else {
        toast.error("something went wrong while duplicating bid")
      }
    } catch (error) {
      console.log("error in duplicating bid: ", error.message)
      toast.error("Error in duplicating bid")
    }
  }

  const handleEditBid = (record) => {
    console.log("record to edit", record);
    let selectedDeal = dealsData.find(
      (deal) => deal._id.toString() === record.dealId._id.toString()
    );
    setSelectedDeal(selectedDeal);
    setEditBidData(record);
    setViewEditBidModal(true);
  };
  const bidColumn = [
    {
      title: "Proposal",
      dataIndex: "bidNumber",
      key: "bidNumber",
      render: (text, record) =>
        record?.bidNumber ? (
          <a
            onClick={() => {
              // console.log("record", record);
              setSelectedBidToView(record);
              setShowBidViewModal(true);
            }}
            style={{
              cursor: "pointer",
              color: "#1677ff", // Ant Design blue
              textDecoration: "underline",
            }}
          >
            {record.bidNumber}
          </a>
        ) : (
          "Not Available"
        ),
    },
    {
      title: "Created Date",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (text, record) => {
        if (record) {
          const date = new Date(record?.dateCreated);
          return date.toLocaleString(); // This will format the date nicely
        }
        return "Not Available";
      },
    },
    {
      title: "Total Cost",
      dataIndex: "totalCost",
      key: "totalCost",
      render: (numeric, record) => record?.totalCost?.toFixed(2) || "N/A",
    },
    {
      title: "Total Margin",
      dataIndex: "totalMargin",
      key: "totalMargin",
      render: (numeric, record) => record?.totalMargin?.toFixed(2) || "N/A",
    },
    {
      dataIndex: "comments",
      key: "comments",
      render: (text, record) =>
        record?.comments?.length > 0 ? (
          // <FaEye onClick={() => handleViewComments(record)} />
          <LiaCommentsSolid onClick={() => handleViewComments(record)} />
        ) : (
          ""
        ),
    },
    {
      dataIndex: "bidStatus",
      key: "bidStatus",
      render: (text, record) => (
        <IoEyeOutline
          size={18}
          style={{ cursor: "pointer", color: "#1677ff" }}
          onClick={() => {
            setSelectedBidForDetail(record);
            setShowBidDetailModal(true);
          }}
        />
      ),
    },
    {
      dataIndex: "bidStatus",
      key: "bidStatus",
      render: (text, record) =>
        ( !isPendingDealsView && ((record?.bidStatus === "REJECTED" || record?.bidStatus === "DRAFT") || (record?.bidStatus === "PENDINGAPPROVAL" && isApproverView))) ? (
          <CiEdit onClick={() => handleEditBid(record)} />
        ) : (
          ""
        ),
    },
    {
      dataIndex: "bidStatus",
      key: "bidStatus",
      render: (text, record) =>
      (
        !isPendingDealsView && <IoDuplicateOutline onClick={() => handleDuplicateBid(record)} />
      )
    },
  ];

  const onExpand = async (expanded, record) => {
    console.log(expanded, record);
    let recordExist = false;
    bidsData.map((b) => {
      if (b.dealId === record._id) {
        recordExist = true;
      }
    });
    try {
      if (expanded && !recordExist) {
        setExpandedRowKeys([...expandedRowKeys, record._id]);
        console.log("isApproverView getDealBids", isApproverView);
        const res = await getDealBids(record._id, isApproverView);
        console.log(res);
      } else {
        setExpandedRowKeys(expandedRowKeys.filter((key) => key !== record._id));
      }
    } catch (error) {
      console.log("Error in expand", error.message);
    }
  };

  const syncData = async () => {
    try {
      setIsSyncLoading(true);
      let response = await BreathAPIs.syncData();
      console.log("response for data sync: ", response);
      if (response.status === 200) {
        if(isPendingDealsView){
          getPendingDeals(pagination.current, pagination.pageSize);
        }else if(isApproverView){
          getAllLiveDeals(true, pagination.current, pagination.pageSize);
        }else{
          getAllLiveDeals(false, pagination.current, pagination.pageSize);
        }
        // await getAllDeals();
        toast.success("Data synched.");
      }
      setIsSyncLoading(false);
    } catch (error) {
      setIsSyncLoading(false);
      toast.error("Error syncing data: ", error.message);
      console.log("error in syncing data: ", error.message);
    }
  };

  const getAllDeals = async (
    forApprover = false,
    current = 1,
    pageSize = 10,
    filters = {}
  ) => {
    try {
      setIsLoading(true);
      console.log("isApproverView: ", isApproverView, "serach query: ", searchQuery);
      setDealsData([]);
      const res = await BreathAPIs.getAllBidDeals(
        current,
        pageSize,
        forApprover,
        filters,
        searchQuery,
        dealsWithBidsFilter
      );
      console.log("res: ", res);
      setPagination({
        total: res.data.pagination.total,
        current: res.data.pagination.current,
        pageSize: res.data.pagination.pageSize,
        totalPages: res.data.pagination.totalPages,
      });
      setDealsData(res.data.bid_deals);
      setLastSync(res.data.lastSync);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
      console.log("Failed to fetch pending bid deals", error);
    }
  };

  const getPendingDeals = async (current = 1, pageSize = 10) => {
    try {
      setIsLoading(true);
      const res = await BreathAPIs.getPendingBidDeals(current, pageSize,  searchQuery, dealsWithBidsFilter);

      setPagination({
        total: res.data.pagination.total,
        current: res.data.pagination.current,
        pageSize: res.data.pagination.pageSize,
        totalPages: res.data.pagination.totalPages,
      });
      setDealsData(res.data.bid_deals);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("Failed to fetch pending bid deals", error);
    }
  };

  const getAllLiveDeals = async (
    forApprover = false,
    current = 1,
    pageSize = 10,
    filters = {}) => {
    try{
      setIsLoading(true);
      const res = await BreathAPIs.getAllLiveBidDeals(current, pageSize, forApprover, searchQuery, dealsWithBidsFilter);
      setPagination({
        total: res.data.pagination.total,
        current: res.data.pagination.current,
        pageSize: res.data.pagination.pageSize,
        totalPages: res.data.pagination.totalPages,
      });
      setDealsData(res.data.bid_deals);
      setLastSync(res.data.lastSync);
      setIsLoading(false);
    }catch(error){
        console.log("Failed to fetch live bid deals", error);
        setIsLoading(false);
    }
  }

  const getDealBids = async (dealId) => {
    console.log("Logging deal ID: ", dealId);
    // setBidsData([]);
    console.log("isApproverView getDealBids func", isApproverView);
    const res = await BreathAPIs.getDealBids(dealId, isApproverView);
    console.log("res bids: ", res.data);
    if (res.data.bidsData.length > 0) {
      if (isApproverView) {
        setBidsDataForApproval((prev) => {
          const merged = [...prev, ...res.data.bidsData];
          const unique = [
            ...new Map(merged.map((item) => [item._id, item])).values(),
          ];
          return unique;
        });
      }
      setBidsData((prev) => {
        const merged = [...prev, ...res.data.bidsData];
        const unique = [
          ...new Map(merged.map((item) => [item._id, item])).values(),
        ];
        return unique;
      });
    }
    //          setExpandedRowKeys((prev) =>
    //     prev.includes(dealId) ? [] : [dealId]
    //   );
  };

  const handleSearch = () => {
    if(isPendingDealsView){
      getPendingDeals(1, pagination.pageSize);
    }else if(isApproverView){
      getAllLiveDeals(true, 1, pagination.pageSize);
    }else{
      getAllLiveDeals(false, 1, pagination.pageSize);
    }
    console.log("searchQuery: ", searchQuery);
  }

  return (
    <>
      <Container>
        <ToastContainer />
        <div className={styles["search-container"]}>
          <Input allowClear placeholder="Search by deal name or address" onChange={(e) => setSearchQuery(e.target.value)} />
          <Select 
          placeholder="Filter Deals with bids/without bids"
          onChange={(value) => setDealsWithBidsFilter(value)}
          options={
            [
            { value: 1, label: "Deals with Bids" },
            { value: 2, label: "Deals without Bids" }
          ]
          }
          allowClear
          style={{ width: 400 }}
          />
            
          <Button color="#18365e" style={{ backgroundColor: "#18365e", color: "white" }} onClick={() => handleSearch()}>Filter</Button>
        </div>
        <div className={styles["top-row"]}>
          {showApproverButton && (
            <Button
              className={
                isApproverView ? styles["approver-button-selected"] : ""
              }
              onClick={() => {
                setIsApproverView(true);
                getAllLiveDeals(true);
                setIsPendingDealsView(false);
              }}
            >
              Approve Bids
            </Button>
          )}
          <Button
            onClick={() => {
              getAllLiveDeals(false);
              setIsApproverView(false);
              setIsPendingDealsView(false);
              
            }}
            className={
                !isApproverView && !isPendingDealsView ? styles["approver-button-selected"] : ""
              }
          >
            Live Deals
          </Button>
          <Button
            onClick={() => {
              getPendingDeals(false);
              setIsApproverView(false);
              setIsPendingDealsView(true);
            }}
            className={
                isPendingDealsView ? styles["approver-button-selected"] : ""
              }
          >
            Past Deals
          </Button>
          <Button
            onClick={() => {
              syncData();
              setIsApproverView(false);
            }}
          >
            {isSyncLoading ? "Syncing..." : "Sync data"}
          </Button>{" "}
          <span>Last sync: {new Date(lastSync).toLocaleString()}</span>
        </div>

        <div className={styles["top-row"]}>
          <div className={styles["lengend-div"]} >
            <div className={styles["legend-approved"]}></div><span > Approved (internal)</span>
          </div>
          <div className={styles["lengend-div"]} >
            <div className={styles["legend-rejected"]}></div><span > Rejected (internal)</span>
          </div>
          <div className={styles["lengend-div"]} >
            <div className={styles["legend-accepted"]}></div><span > Accepted by client</span>
          </div>
          
        </div>

        <Table
          loading={isLoading}
          pagination={pagination}
          bordered
          onChange={handleTableChange}
          columns={column}
          dataSource={dealsData}
          rowKey={"_id"}
          expandable={{
            expandedRowRender: (record) => (
              <>
                <Table
                  dataSource={
                    isApproverView
                      ? bidsDataForApproval.filter(
                        (bid) => bid.dealId._id === record._id
                      )
                      : bidsData.filter((bid) => bid.dealId._id === record._id)
                  }
                  columns={bidColumn}
                  rowKey="_id"
                  pagination={false}
                  rowClassName={(bid) => bid.acceptedProposal ? styles['accepted-bid-row'] : (bid.bidStatus === "APPROVED" ? styles['approved-bid-row'] : (bid.bidStatus === "REJECTED" ? styles['rejected-bid-row'] : ''))}
                />
              </>
            ),
            onExpand: onExpand,
            expandedRowKeys: expandedRowKeys,
            // expandRowByClick: true,
            // expandedRowKeys: expandedRowKeys,
            // onExpand: (_, record) => getDealBids(record._id),
            // expandedRowRender: (record) =>
            //   bidsData[record._id] ? (
            //     <Table
            //       dataSource={bidsData[record._id]}
            //       columns={bidColumn}
            //       pagination={false}
            //     />
            //   ) : <>Not Bids Available</>,
          }}
        />
      </Container>

      {showBidCreateModel && (
        <Modal
          open={showBidCreateModel}
          onCancel={() => {
            setShowBidCreateModel(false);
            setSelectedDeal(null);
          }}
          footer={null}
          centered
          width={"80%"}
        >
          <CreateBid
            selectedDeal={selectedDeal}
            setShowBidCreateModel={setShowBidCreateModel}
            showBidCreateModel={showBidCreateModel}
            email={email}
            phone={phone}
            getDealBids={getDealBids}
          />
        </Modal>
      )}
      {
        dealModalView && (
          <Modal
            open={dealModalView}
            onCancel={() => {
              setDealModalView(false);
              setDealToView(null);
            }}
            footer={null}
            centered
            width={"50%"}
          >
            <ViewDeal dealToView={dealToView} />
          </Modal>
        )

      }

      {
        // showBidViewModal && (
        //   <Modal
        //     open={showBidViewModal}
        //     onCancel={() => {
        //       setShowBidViewModal(false);
        //       setSelectedBidToView(null);
        //     }}
        //     footer={null}
        //     centered
        //     width={"80%"}
        //   >
        //     {/* <CreateBid selectedDeal={selectedDeal} setShowBidCreateModel={setShowBidCreateModel} showBidCreateModel={showBidCreateModel}/> */}
        //     <ViewBid bidToView={selectedBidToView}></ViewBid>
        //   </Modal>
        // )
      }
      {/* {console.log("showBidViewModal", showBidViewModal)} */}
      {showBidViewModal && (
        <Drawer
          title={`${selectedBidToView.dealId?.dealname} - ${selectedBidToView.bidNumber}`}
          placement="right"
          closable={false}
          onClose={() => setShowBidViewModal(false)}
          open={showBidViewModal}
          // getContainer={false}
          width={"70%"}
        >
          <ViewBid
            bidToView={selectedBidToView}
            isApproverView={isApproverView}
            getDealBids={getDealBids}
            getAllLiveDeals={getAllLiveDeals}
            setShowBidViewModal={setShowBidViewModal}
            // hasAcceptedBid={bidsData.some(
            //   (bid) =>
            //     bid.dealId._id === selectedBidToView?.dealId?._id &&
            //     bid.acceptedProposal &&
            //     bid._id !== selectedBidToView?._id
            // )}
          ></ViewBid>
        </Drawer>
      )}

      {showCommentsModal && (
        <Modal
          open={showCommentsModal}
          onCancel={() => {
            setShowCommentsModal(false);
            setViewCommentsForBid(null);
          }}
          footer={null}
          centered
        >
          {viewCommentsForBid && viewCommentsForBid.length > 0 && (
            <p>
              <b>Comments:</b>

              {viewCommentsForBid.map((comment, index) => (
                <div key={index}>
                  <br></br>
                  <p style={{ margin: "0" }}>
                    {index + 1}.{comment}
                  </p>
                </div>
              ))}
            </p>
          )}
        </Modal>
      )}
      <BidDetailModal
        bid={selectedBidForDetail}
        open={showBidDetailModal}
        onClose={() => {
          setShowBidDetailModal(false);
          setSelectedBidForDetail(null);
        }}
      />

      {viewEditBidModal && (
        <Modal
          open={viewEditBidModal}
          onCancel={() => {
            setViewEditBidModal(false);
            setEditBidData(null);
          }}
          footer={null}
          centered
          width={"80%"}
        >
          <div>
            <CreateBid
              selectedDeal={selectedDeal}
              setShowBidCreateModel={setViewEditBidModal}
              showBidCreateModel={viewEditBidModal}
              email={email}
              phone={phone}
              editBid={true}
              bidData={editBidData}
              getDealBids={getDealBids}
            ></CreateBid>
          </div>
        </Modal>
      )}

      {(showHubspotUpdateModal && selectedDealForHubspotUpdate != null) && (
        <Modal
          open={showHubspotUpdateModal}
          onCancel={() => {
            setSelectedDealForHubspotUpdate(null);
            setShowHubspotUpdateModal(false)
          }}
          footer={null}
          centered
          width={"80%"}
        >
          <div>
            <BidDataUpdateHubSpot
              selectedDeal={selectedDealForHubspotUpdate}
              getDealBids={getDealBids}
              selectedBids={bidsData.filter(
                (bid) => bid.dealId._id === selectedDealForHubspotUpdate._id
              )}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

Deals.propTypes = {
  user: PropTypes.string,
  userID: PropTypes.string,
  userGroups: PropTypes.array,
  phone: PropTypes.string,
  email: PropTypes.string,
};
const mapStateToProps = (state) => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  phone: state.auth && state.auth.user ? state.auth.user.phone : false,
  email: state.auth && state.auth.user ? state.auth.user.email : false,
});
export default connect(mapStateToProps, {})(Deals);
